import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Row
} from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import React, { Fragment } from "react";

import BudgetItemFormTable from "./BudgetItemFormTable";
import { CancelButton } from "../../elements/ActionButtons/CancelButton";
// import ClientProjectSelect from "../ClientProject/ClientProjectSelect";
import { DeleteButton } from "../../elements/ActionButtons/DeleteButton";
import ProjectSelect from "../Project/ProjectSelect";
import Queries from "../../queries/queries2";
import { Query } from "react-apollo";
import { SaveButton } from "../../elements/ActionButtons";
import Spinner from "../../elements/Spinner/Spinner";
import Switch from "react-bootstrap-switch";
import { compose } from "recompose";

class BudgetItemForm extends React.Component {
  constructor(props) {
    super(props);

    // form state
    this.state = {
      ...props.values,
      deleteButtonText: "ids_delete",
      errors: {}
    };

    // console.log("34 - props", props);
    // console.log("35 - state", this.state);
  }

  validate = () => {
    const errors = {
      yearError: !!!this.state.year ? "error" : null
      // monthError: !!!this.state.month ? "error" : null
    };
    this.setState({ errors });

    return !!!errors.yearError;
    // && !!!errors.monthError;
  };

  updateBudgetItemTable = tableData => {
    // console.log("updateBudgetitem", tableData);
    // console.log("updateBudgetitem(S)", this.state);

    if (this.state.originalItemsData === undefined) {
      // console.log("54 - updateOriginalItems", tableData);
      const data = JSON.stringify(tableData);
      this.setState({ items: tableData, originalItemsData: data });
    }
    else {
      this.setState({ items: tableData });
    }
  };

  updateBudgetIsReal = isReal => {
    if (this.state.originalIsRealData === undefined) {
      // console.log("64 - originalIsRealData", isReal);
      this.setState({ isReal: isReal, originalIsRealData: isReal });
    }
    else {
      this.setState({ isReal: isReal });
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    // const variables = {
    //   companyId: this.state.companyId,
    //   tiersId: this.state.tiersId
    // };
    // const res = await this.props.getBudgetItems.refetch(variables);
    // console.log("res", res);
  };

  static getDerivedStateFromProps = async (props, state) => {
    // console.log("61 - getDerivedStateFromProps", props, state);
    if (
      props.values &&
      props.values.previousNextCommand &&
      (props.values.tiersId !== state.tiersId ||
        props.values.categoryId !== state.categoryId ||
        props.values.projectId !== state.projectId ||
        props.values.isReal !== state.isReal)
    ) {
      state.categoryId = props.values.categoryId;
      state.projectId = props.values.projectId;
      state.tiersId = props.values.tiersId;
      state.isReal = props.values.isReal;

      state.originalItemsData = undefined;
      state.originalIsRealData = undefined;
      props.setPreviousNextCommand(false);
    }
  };

  render = () => {
    const {
      intl,
      sendNotification,
      cancel,
      save,
      deleteBudgetItems,
      currencyId,
      workInProgress,
      role
      // companyId
      // disabled,
      //tiersId
    } = this.props;

    let { year, companyId, projectId, tiersId, isReal } = this.state;

    let saveDisable = true;
    // console.log("118 - this.state.originalIsRealData=", this.state.originalIsRealData);
    // console.log("118 - this.state.isReal=", this.state.isReal)
    // console.log("119 - this.state.originalItemsData=", this.state.originalItemsData);

    // if (this.state.originalIsRealData === undefined) {
    //   this.state.originalIsRealData = this.state.isReal;
    // }

    if (this.state.originalItemsData && this.state.originalIsRealData !== undefined) {
      if (
        this.state.originalItemsData !== JSON.stringify(this.state.items) ||
        this.state.originalIsRealData !== this.state.isReal
      ) {
        saveDisable = false;
      }
    }
    this.props.setShowAlertPreviousNext(!!!saveDisable);

    // console.log("113 - data=",
    //   companyId,
    //   tiersId,
    //   year,
    //   projectId
    // );

    const disabled = false;
    return (
      <React.Fragment>
        <Row>
          <Col xs={2}>
            <ControlLabel>
              {intl.formatMessage({ id: "ids_year" })}
            </ControlLabel>
          </Col>
          <Col xs={4}>
            <FormGroup validationState={this.state.errors.yearError}>
              <FormControl
                disabled={!!disabled}
                name="year"
                type="number"
                value={year}
                onChange={event =>
                  event.target.value &&
                  this.setState({
                    year: parseInt(event.target.value),
                    originalItemsData: undefined,
                    originalIsRealData: undefined
                  })
                }
              />
            </FormGroup>
          </Col>
          <React.Fragment>
            <Col xs={2}>
              <ControlLabel>
                {intl.formatMessage({ id: "ids_project" })}
              </ControlLabel>
            </Col>
            <Col xs={4}>
              <FormGroup>
                <ProjectSelect
                  disabled={!!disabled}
                  sendNotification={sendNotification}
                  companyId={companyId}
                  value={projectId || ""}
                  creatable={role==="ADMIN"}
                  onSelected={e => {
                    if (e) {
                      this.setState({
                        projectId: e.value,
                        originalItemsData: undefined,
                        originalIsRealData: undefined
                      });
                    } else {
                      // reset field
                      this.setState({
                        projectId: "",
                        originalItemsData: undefined,
                        originalIsRealData: undefined
                      });
                    }
                  }}                  
                />
              </FormGroup>
            </Col>
          </React.Fragment>
        </Row>
        <Row>
          <Col xs={12}>
            <Query
              query={Queries.getBudgetItemsByYear}
              variables={{
                companyId,
                tiersId,
                year,
                projectId
              }}
            >
              {({
                loading,
                error,
                data,
                fetchMore,
                subscribeToMore,
                refetch
              }) => {
                if (loading) return <Spinner size="lg" fullScreen />;
                if (error) return `Error! ${error.message}`;
                const getBudgetItemsByYear = data && data.getBudgetItemsByYear;
                return (
                  <BudgetItemFormTable
                    data={getBudgetItemsByYear}
                    companyId={companyId}
                    currencyId={currencyId}
                    tiersId={tiersId}
                    year={year}
                    projectId={projectId || ""}
                    updateBudgetItemTable={this.updateBudgetItemTable}
                    updateBudgetIsReal={this.updateBudgetIsReal}
                    globalIsReal={isReal}
                    budgetType={"Client"}
                  />
                );
              }}
            </Query>

            {/* <Query
            query={Queries.getBudgetItemsByYear}
            fetchPolicy="network-only"
            // fetchPolicy="cache-and-network"
            variables={{
              companyId,
              tiersId,
              year,sta
              projectId
            }}>
            {({
              loading,
              error,
              data,
              fetchMore,
              subscribeToMore,
              refetch
            }) => {
              if (loading) return <Spinner size="lg" fullScreen />;
              if (error) return `Error! ${error.message}`;
              const getBudgetItemsByYear = data && data.getBudgetItemsByYear;
              return <div>TOTO</div>;
              return (
                <BudgetItemFormTable
                  data={getBudgetItemsByYear}
                  companyId={companyId}
                  currencyId={currencyId}
                  tiersId={tiersId}
                  year={year}
                  projectId={projectId || ""}
                  updateBudgetItemTable={this.updateBudgetItemTable}
                />
              );
            }}
            }
          </Query> */}
          </Col>

          <Col xs={5}>
            <div className="side-modal-footer">
              <Fragment>
                <span style={{ marginRight: "12px" }}>
                  <FormattedMessage id="ids_situation" />
                  <FormattedMessage id="ids_colon" />{" "}
                </span>
                <span style={{ marginRight: "12px" }}>
                  <FormattedMessage id="ids_real" />
                </span>
                <Switch
                  onText=""
                  offText=""
                  value={!isReal} // this.state.isReal}
                  onChange={e => {
                    console.log("onchange...", e);
                    const value = !e.state.value;
                    this.setState({ isReal: value });
                  }}
                />
                <span style={{ marginRight: "240px", marginLeft: "12px" }}>
                  <FormattedMessage id="ids_budget" />
                </span>
              </Fragment>

              <DeleteButton
                disabled={!!workInProgress}
                wd
                className="pull-left"
                // margin-left-20
                ids={this.state.deleteButtonText}
                onClick={() => {
                  if (this.state.deleteButtonText === "ids_delete") {
                    this.setState({ deleteButtonText: "ids_confirm" });
                  }
                  else if (this.state.deleteButtonText === "ids_confirm") {
                    this.setState({ deleteButtonText: "ids_delete" });
                    return deleteBudgetItems(this.state);
                  }                  
                }}
              />
              {/* <CancelButton wd onClick={cancel} /> */}
              <SaveButton
                className="btn-fill pull-right"
                disabled={saveDisable}
                workInProgress={!!workInProgress}
                onMouseDown={() =>
                  setTimeout(() => {
                    if (this.validate()) {
                      console.log("273 - OnClisk SAVE...");
                      const data = JSON.stringify(this.state.items);
                      this.setState({ originalItemsData: data, originalIsRealData: this.state.isReal });
                      save(this.state);
                    }
                  }, 250)
                }
              />
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  };
}

export default compose(injectIntl)(BudgetItemForm);
